import React, {} from 'react';
import { Title } from '@wb-tech/ui-react/v2';
import { useClassnames } from '@wb-tech/ui-react';
import { useTranslation } from 'react-i18next';

import style from '#route/finances/components/balance/index.module.pcss';
import { Skeleton } from '#component/ui/skeleton';

interface ISumTextProps {
    value: string,
    isLoading: boolean,
    isUniversalAccount?: boolean,
    isBonus?: boolean
}

export const CURRENCY = {
    rub  : '₽',
    usd  : '$',
    eur  : '€',
    cny  : '¥',
    balls: 'B'
};

export const SumText = ({ value, isLoading, isBonus, isUniversalAccount = false }: ISumTextProps) => {
    const cn = useClassnames(style);
    const { t } = useTranslation();

    if(isLoading) {
        return (
            <Skeleton
                presetWidth={150}
                presetHeight={28}
            />
        );
    }

    const renderValue = () => {
        if(isUniversalAccount) {
            return (
                <React.Fragment>
                    {t('routes.finances.balance.sum.value-unified', { value: `${value} ` })}
                    <span className={cn('unified')}>{ isBonus ? CURRENCY.balls : CURRENCY.rub}</span>
                </React.Fragment>
            );
        }

        return <React.Fragment>{t('routes.finances.balance.sum.value', { value })}</React.Fragment>;
    };

    return (
        <Title
            tagName="h3"
            className={cn('finances-balance__sum-value')}
        >
            {renderValue()}
        </Title>
    );
};
